/** @format */

import {LockClosedIcon} from '@heroicons/react/solid'
import React, {useState} from 'react'

import Switch from '@src/components/tailwind/Switch'

import * as toast from '@src/toast'

import {FieldValidation} from '../FieldValidation'
import {useValidationApi} from '../ValidationApi'

type RequiredSwitchProps = {
  fieldName: string
  required: FieldValidation['required']
}

export function RequiredSwitch(props: RequiredSwitchProps) {
  const {fieldName, required} = props
  const addedBy = required?.plugins
  const disabled = !!addedBy

  const [checked, setChecked] = useState(required?.value ?? false)
  const api = useValidationApi()

  async function updateRequired(required: boolean) {
    const prev = checked
    setChecked(required)
    try {
      await api.update(fieldName, {required})
    } catch (err) {
      // rollback on error so the local state matches the remote state
      setChecked(prev)
      toast.error(err)
    }
  }

  return (
    <Switch
      title="Required"
      checked={checked}
      onChange={updateRequired}
      disabled={disabled}
      description={
        addedBy && (
          <div className="flex items-center gap-1 text-xs text-gray-500">
            <LockClosedIcon className="h-4 w-4 shrink-0" />
            <p>Required by {[...addedBy].join(', ')}.</p>
          </div>
        )
      }
    />
  )
}
